import { Component } from "react";

import "./style.scss";

let tabItemId = 0;

class TabItem extends Component {

    constructor(props){
        super(props)
        this.id = tabItemId++;
    }

    render() {
        return (
            <>
                <div className={`tab-item ${this.props.className}`} key={`tab-item-${this.id}`}>{this.props.children}</div>
            </>
        )
    }
}


class TabView extends Component {

    state={
        page:this.props.page || 0
    }

    gotoPage=(page)=>{
        this.setState({page:page})
        this.props.onPageChange(page);
    }

    componentDidUpdate(prevProps){
        if(prevProps.page!==this.props.page){
            this.setState({page:this.props.page})
        }
    }

    render() {
        return (
            <>
                <div className="tab-view">
                    <div className="tab-menu row lock">
                        {this.props.children.map((child, i) => {
                            return <div className={`tab-bt ${this.state.page===i ? "active" : ""}`} key={`tab-bt-${i}`} onClick={()=>this.gotoPage(i)}>{child.props.title}</div>
                        })}
                    </div>
                    <div className="tab-items">
                        {/* {this.props.children[this.state.page]} */}
                        {this.props.children}
                    </div>
                </div>
            </>
        )
    }
}

export { TabView, TabItem };